// src/api/eventApi.js
import axios from 'axios';
import endpoints from '../endpoints';

export const fetchEventList = async (pageNumber, pageSize) => {
    const response = await axios.get(endpoints.eventList, {
        params: {
            pageNumber,
            pageSize,
        },
    });

    const data = response.data.page;

    // 返回分頁資訊和內容
    return {
        content: data.content,
        totalPages: data.totalPages,
        totalElements: data.totalElements,
        pageNumber: data.pageable.pageNumber,
        pageSize: data.pageable.pageSize,
    };
};

export const fetchSelectEventList = async (pageNumber, pageSize) => {
    const response = await axios.get(endpoints.selectEventList, {
        params: {
            pageNumber,
            pageSize,
        },
    });

    const data = response.data.page;

    // 返回分頁資訊和內容
    return {
        content: data.content,
        totalPages: data.totalPages,
        totalElements: data.totalElements,
        pageNumber: data.pageable.pageNumber,
        pageSize: data.pageable.pageSize,
    };
};
